/*
  Polyfills
  @babel/polyfill is deprecated in newer versions https://babeljs.io/docs/en/babel-polyfill/
  in favor of core-js/stable and regenerator-runtime/runtime
*/
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'get-root-node-polyfill/implement'; // fix getRootNode error on IE and edge
import './common/prototypes';

// Start the real imports
import React from 'react';
import ReactDOM from 'react-dom';
import { hot } from 'react-hot-loader/root';
import * as Sentry from '@sentry/react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';

import { Error500 } from 'barnyard/pages';
import { Button } from 'barnyard/components';
import { rootUrl } from 'barnyard/utils';


library.add(fal);


const errorPage = () => (
  <Error500 showButton={false}>
    <Button node='a' size='lg' color='primary' href={rootUrl()}>Return Home</Button>
  </Error500>
);


export const render = (App, isHot = true) => {
  /* eslint-disable no-undef */
  /* These values are resolved by webpack when building. See webpack.config.js */
  if (SENTRY_ENABLED) {
    Sentry.init({
      dsn: SENTRY_DSN,
      release: SENTRY_RELEASE_VERSION,
    });

    Sentry.setUser(window.user);
  }
  /* eslint-enable no-undef */

  const reactBody = document.getElementById('ReactBody');

  let ActualApp = App;

  if (isHot) {
    ActualApp = hot(ActualApp);
  }

  if (reactBody) {
    ReactDOM.render(
      <Sentry.ErrorBoundary fallback={errorPage}>
        <ActualApp />
      </Sentry.ErrorBoundary>,
      reactBody
    );
  }
};
